import { Component, Input, OnInit } from '@angular/core';
import { TextBoxNext } from '@components';
import {
	DomainService,
	Label,
	LanguageService,
	StorageService,
	TempKey,
} from '@services/public';
import { skillUID } from 'jakapa-utilities-lite';
import { ReflectionData, ReflectionPage } from '../common';

const PAGE_PATH: string = 'skillBuilders.reflection.pages.scores';

@Component({
	selector: 'app-member-skill-builder-reflection-scores',
	templateUrl: './scores.component.html',
	styleUrls: ['./scores.component.scss'],
})
export class MemberSkillBuilderReflectionScoresComponent implements OnInit {
	@Input() data: ReflectionData;
	next: TextBoxNext = { onClick: this.nextOnClick.bind(this) };

	// Page langauge.
	page: { [key: string]: string } = {
		selfScores: '',
		noSelfScores: '',
		peerScores: '',
		noPeerScores: '',
		insight: '',
		errorRequired: '',
		additionalQuestions: '',
	};
	labels: { [key in Label]?: string } = {};

	constructor(
		private _domainSvc: DomainService,
		private _languageSvc: LanguageService,
		private _storageSvc: StorageService,
	) {}

	ngOnInit(): void {
		// Get page language.
		this._languageSvc
			.get([PAGE_PATH], {
				[PAGE_PATH]: {
					skills: `<br><h5>${this.data.scores
						.map((score) => this._domainSvc.getSkill(score.uid).name)
						.join('<br>')}</h5>`,
				},
			})
			.then((value) => {
				if (typeof value[PAGE_PATH] === 'object' && value[PAGE_PATH] !== null)
					this.page = value[PAGE_PATH];
			});
		this._languageSvc.getLabels(this.labels);
	}

	getSkillName(uid: skillUID): string {
		return this._domainSvc.getSkill(uid).name;
	}

	get noSelfScores(): boolean {
		return this.data.scores.filter((score) => score.self).length === 0;
	}

	get noPeerScores(): boolean {
		return this.data.scores.filter((score) => score.peer).length === 0;
	}

	nextOnClick(insight: string): void {
		this._storageSvc.setTempStorage(TempKey.REFLECTION, {
			...this.data,
			page: ReflectionPage.SKILL,
			insight,
		});
	}
}
